import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import { createContext } from 'react';
import { AcceptDeclineFlowStore } from '~web/store/assignments/accept-decline-flow-store';
import { MalformedLinkStore } from '~web/store/assignments/malformed-link.store';
import { AuthFlowStore } from '~web/store/auth-flow-store';
import { AuthStore } from '~web/store/auth-store';
import { BaseStore } from '~web/store/base/base-store';
import { DiscoverActionStore } from '~web/store/discover/discover-action-store';
import { EventPageActionStore } from '~web/store/event/event-page-action-store';
import { HistoryBlockStore } from '~web/store/history-block-store';
import { SeatsStore } from '~web/store/seating/seats-store';
import { DeleteListingStore } from '~web/store/selling/delete-listing-store';
import { SellingCheckoutStore } from '~web/store/selling/selling-checkout-store';
import { SellingStore } from '~web/store/selling/selling-store';
import { TokenAssignmentFlowStore } from '~web/store/token/token-assignment-flow-store';
import { TokenSelectionStore } from '~web/store/token/token-selection-store';
import { OfferGroupsStore } from '~web/store/transaction/offer-groups-store';
import { PaymentSectionFlowStore } from '~web/store/transaction/payment-section-flow-store';
import { UserPreferencesStore } from '~web/store/user-preferences-store';
import { UserProfileFlowStore } from '~web/store/user-profile/user-profile-flow-store';
import { UserProfileStore } from '~web/store/user-profile/user-profile-store';

/**
 * List ALL the stores here.
 */
const authFlowStore: AuthFlowStore = new AuthFlowStore();
const authStore: AuthStore = new AuthStore();
const clientToPromoterAssignmentStore: AcceptDeclineFlowStore = new AcceptDeclineFlowStore();
const clientToUserAssignmentStore: AcceptDeclineFlowStore = new AcceptDeclineFlowStore();
const deleteListingStore: DeleteListingStore = new DeleteListingStore();
const discoverActionStore: DiscoverActionStore = new DiscoverActionStore();
const eventPageActionStore: EventPageActionStore = new EventPageActionStore();
const historyBlockStore: HistoryBlockStore = new HistoryBlockStore();
const malformedLinkStore: MalformedLinkStore = new MalformedLinkStore();
const offerGroupsStore: OfferGroupsStore = new OfferGroupsStore();
const paymentSectionFlowStore: PaymentSectionFlowStore = new PaymentSectionFlowStore();
const promoterToUserAssignmentStore: AcceptDeclineFlowStore = new AcceptDeclineFlowStore();
const seatsStore: SeatsStore = new SeatsStore();
const sellingCheckoutStore: SellingCheckoutStore = new SellingCheckoutStore();
const sellingStore: SellingStore = new SellingStore();
const tokenAssignmentFlowStore: TokenAssignmentFlowStore = new TokenAssignmentFlowStore();
const tokenSelectionStore: TokenSelectionStore = new TokenSelectionStore();
const userPreferencesStore: UserPreferencesStore = new UserPreferencesStore();
const userProfileStore: UserProfileStore = new UserProfileStore();
const userProfileFlowStore: UserProfileFlowStore = new UserProfileFlowStore();
const userToUserAssignmentStore: AcceptDeclineFlowStore = new AcceptDeclineFlowStore();

interface StoreContainer {
  [key: string]: BaseStore;
}

/**
 * Export ALL persisted stores here.
 */
export const persistedStores: StoreContainer = {
  authStore,
  userPreferencesStore,
  userProfileStore,
};

/**
 * Export ALL the stores here.
 */
export const stores: StoreContainer = {
  authFlowStore,
  clientToPromoterAssignmentStore,
  clientToUserAssignmentStore,
  deleteListingStore,
  discoverActionStore,
  eventPageActionStore,
  historyBlockStore,
  malformedLinkStore,
  offerGroupsStore,
  paymentSectionFlowStore,
  promoterToUserAssignmentStore,
  seatsStore,
  sellingCheckoutStore,
  sellingStore,
  tokenAssignmentFlowStore,
  tokenSelectionStore,
  userProfileFlowStore,
  userToUserAssignmentStore,
  ...persistedStores,
};

/**
 * All stores contexts will be store here
 */
export const storeContext = new WeakMap();

/**
 * Creates all the store contexts.
 * Call this at the app initialization
 */
export const initializeStoreContexts = (): void => {
  forEachObjIndexed((store: BaseStore) => {
    storeContext.set(store, createContext(store));
  }, stores);
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/index.ts